export const MODAL_BODY_CLASS = 'modal_opened';

export const PATHS_TO_BLOCK_DIRECT_CONNECT = ['/login/success'];
